import { useMemo } from 'react'
import { useHistory } from 'react-router-dom'

const useNavigator = () => {
  const history = useHistory()
  const navigator = useMemo(() => {
    if (document.getElementById('spatarget')) {
      return history.push
    }

    return window.location.assign.bind(window.location)
  }, [history.push])

  return navigator
}

export { useNavigator }
